import { useInterstitialQuery } from '@wwe-portal/web/providers/queries/interstitial';
import { useGetCurrencies } from '@wwe-portal/web/providers/queries/offer';
import { useGetUserInfo } from '@wwe-portal/web/providers/queries/user-info';
import { OfferData } from '@wwe-portal/entities/offer.type';

export const useGetPaymentContext = () => {
  const { data: currencies } = useGetCurrencies();
  const { data: currentUser } = useGetUserInfo();
  const { data: interstitialData } = useInterstitialQuery();

  const getUpsellData = (purchasedOfferData: OfferData) => {
    const upsellOffer = interstitialData?.data?.data.upsells?.find(
      (upsellItem) =>
        upsellItem.purchasedOfferId === purchasedOfferData.OffersID
    );

    if (!upsellOffer) return undefined;
    return {
      intersititalData: upsellOffer,
      offerId: upsellOffer.suggestedOfferId,
    };
  };

  return (
    offerData: OfferData,
    screenCategory?: string,
    metadata?: Record<string, string>
  ) => {
    return {
      currencies: currencies?.data.data ?? [],
      currentUser,
      balance: {
        webCoin: currentUser?.webCoin,
        ruby: currentUser?.ruby,
        clubCoin: currentUser?.clubCoin,
      },
      upsellData: offerData ? getUpsellData(offerData) : undefined,
      screenCategory,
      metadata,
    };
  };
};
